var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_consultation",
    transform: "translate(-141 -1977.729)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2366",
    "data-name": "Group 2366",
    transform: "translate(141 1977.729)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2365",
    "data-name": "Group 2365"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5323",
    "data-name": "Path 5323",
    d: "M40.5,81A40.5,40.5,0,1,1,81,40.5,40.546,40.546,0,0,1,40.5,81Zm0-76.14A35.64,35.64,0,1,0,76.14,40.5,35.68,35.68,0,0,0,40.5,4.86Z",
    fill: "#01358d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5324",
    "data-name": "Path 5324",
    d: "M44.246,20A24.246,24.246,0,1,0,68.491,44.246,24.273,24.273,0,0,0,44.246,20ZM45.7,65.527V61.7H42.791v3.824A21.362,21.362,0,0,1,22.964,45.7h3.824v-2.91H22.965A21.361,21.361,0,0,1,42.791,22.964v3.824H45.7V22.965A21.361,21.361,0,0,1,65.527,42.791H61.7V45.7h3.824A21.363,21.363,0,0,1,45.7,65.527Z",
    transform: "translate(-3.746 -3.746)",
    fill: "#f9556d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5325",
    "data-name": "Path 5325",
    d: "M36.408,52.1a19.632,19.632,0,0,1,4.806-2.138c.233-.076.465-.18.7-.255l.048-.03a6.044,6.044,0,0,0,.932-.385,1.134,1.134,0,0,0,.05-.156A14.4,14.4,0,0,1,40.7,41.6a5.691,5.691,0,0,1,1.984-4.8,4.353,4.353,0,0,0-1.964-.393c-1.939,0-3.511.775-3.511,3.556a9.641,9.641,0,0,0,1.726,5.427c-.011.1-.022.208-.041.311a1.1,1.1,0,0,1-.424.757,5.187,5.187,0,0,1-.949.4A16.229,16.229,0,0,0,33.6,48.5a3.731,3.731,0,0,0-1.271,1.913,6.889,6.889,0,0,0-.322,2.4h3.662A1.461,1.461,0,0,1,36.408,52.1Z",
    transform: "translate(-6.094 -6.943)",
    fill: "#f9556d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5326",
    "data-name": "Path 5326",
    d: "M63.877,48.524a16.4,16.4,0,0,0-3.925-1.655A5.247,5.247,0,0,1,59,46.462a1.1,1.1,0,0,1-.424-.761,3.3,3.3,0,0,1-.05-.453,9.8,9.8,0,0,0,1.619-5.288c0-2.783-1.572-3.557-3.51-3.557a4.319,4.319,0,0,0-1.986.406,5.7,5.7,0,0,1,1.968,4.784A14.415,14.415,0,0,1,54.5,48.954c0,.02.008.045.011.067a1.5,1.5,0,0,0,.079.271,6.838,6.838,0,0,0,.994.411l.562.186a20.5,20.5,0,0,1,4.928,2.25c.248.163.483.19.7.678h3.695a6.946,6.946,0,0,0-.322-2.4A3.679,3.679,0,0,0,63.877,48.524Z",
    transform: "translate(-10.378 -6.941)",
    fill: "#f9556d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5327",
    "data-name": "Path 5327",
    d: "M56.88,53.127a21.889,21.889,0,0,0-5.232-2.212,6.977,6.977,0,0,1-1.268-.548,1.455,1.455,0,0,1-.566-1.013,5.231,5.231,0,0,1-.07-.605A13.038,13.038,0,0,0,51.9,41.7c0-3.71-2.1-4.744-4.681-4.744s-4.681,1.033-4.681,4.742a12.867,12.867,0,0,0,2.3,7.236c-.013.138-.029.277-.054.416a1.464,1.464,0,0,1-.566,1.008,7.068,7.068,0,0,1-1.267.535,21.778,21.778,0,0,0-5.232,2.187,4.9,4.9,0,0,0-1.7,2.523,10.217,10.217,0,0,0-.428,3.17H59a10.28,10.28,0,0,0-.428-3.17A4.774,4.774,0,0,0,56.88,53.127Z",
    transform: "translate(-6.802 -7.058)",
    fill: "#f9556d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1597",
    "data-name": "Ellipse 1597",
    transform: "translate(205.729 1989.95)",
    fill: "#f9556d",
    stroke: "#fff",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 5.75,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.243411f68a8c8b321d969f0e7c25e465.svg";
export { ForwardRef as ReactComponent };